import { Fragment, useMemo } from "react";
import type { ZypeSubscription } from "@inferno/renderer-shared-core";
import Heading from "../../../../../../core/ui/Heading.component";
import { isGiftSubscription } from "../../../../lib/coastUser";
import { CoastUserNoSubscription } from "./CoastUserNoSubscription.component";
import { CoastUserSubscription } from "./CoastUserSubscription.component";

interface CoastUserSubscriptionsListProps {
  onEdit: (sub: ZypeSubscription, idx: number) => void;
  subscriptions?: ZypeSubscription[];
}

export function CoastUserSubscriptionsList({ subscriptions, onEdit }: CoastUserSubscriptionsListProps) {
  const hasGiftSubscription = useMemo(() => subscriptions?.some(s => isGiftSubscription(s)), [subscriptions]);

  return (
    <section className="component-account-subscriptions-list spaced-out-block">
      <Heading level={3}>Subscriptions</Heading>

      {subscriptions?.length ? (
        subscriptions.map((sub, i) => (
          <Fragment key={sub._id}>
            <CoastUserSubscription onEdit={s => onEdit(s, i)} subscription={sub} />
            {subscriptions.length > 1 && i < subscriptions.length - 1 ? <hr className="divider partial" /> : null}
          </Fragment>
        ))
      ) : (
        <CoastUserNoSubscription />
      )}

      {/* That won't be the case once we support future subs */}
      {hasGiftSubscription ? (
        <p className="cancel-subscription-help">
          *You can&apos;t subscribe to another or change you current plan until your gift subscription has expired.
        </p>
      ) : null}
    </section>
  );
}
